export function deploymentReleaseStage(appEnvironment) {
    return appEnvironment || 'development'
}

export function releaseStageConfig(releaseStage) {
    return {
        releaseStage: deploymentReleaseStage(releaseStage),
        enabledReleaseStages: ['production'],
    }
}
